import axios from './axios';

// Thin wrappers over the admin partner endpoints (/admin/partners/*). All calls
// go through the shared axios instance (token + global notifications). Mutations
// pass { skipNotify: 'success' } because the views render their own snackbars.

export const fetchPartnerStats = () => axios.get('/admin/partners/stats');

export const fetchPartners = (params) => axios.get('/admin/partners', { params });

export const fetchPartnerDetail = (id) => axios.get(`/admin/partners/${id}`);

export const reviewKyc = (id, action, reason) =>
  axios.put(`/admin/partners/${id}/kyc`, { action, reason }, { skipNotify: 'success' });

export const updatePartnerStatus = (id, body) =>
  axios.put(`/admin/partners/${id}/status`, body, { skipNotify: 'success' });

export const adjustPartnerWallet = (id, amount, note) =>
  axios.post(`/admin/partners/${id}/adjust`, { amount, note }, { skipNotify: 'success' });

export const fetchPayouts = (params) => axios.get('/admin/partners/payouts', { params });

export const processPayout = (id, body) =>
  axios.put(`/admin/partners/payouts/${id}`, body, { skipNotify: 'success' });

export const fetchPartnerSettings = () => axios.get('/admin/partners/settings');

export const updatePartnerSettings = (body) =>
  axios.put('/admin/partners/settings', body, { skipNotify: 'success' });

// Fetch a KYC document as an object URL. Sensitive docs are served only through
// an admin-auth route, so we must fetch as a blob (carrying the token via the
// axios interceptor) rather than pointing an <img src> at the URL.
export const fetchKycDocUrl = async (id, field) => {
  const res = await axios.get(`/admin/partners/${id}/kyc/${field}`, {
    responseType: 'blob',
    skipNotify: true,
  });
  return { url: URL.createObjectURL(res.data), type: res.data.type };
};
